// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_inE","cls2":"News-cls2_Ac0 News-cls1_inE"};